import React from "react";
// import { IconTeaserGridData } from "./icon-teaser-grid.mock";
import classNames from "classnames";
import CustomPrimaryCtaButton from "ReactComponents/Shared/CustomPrimaryCtaButton/custom-primary-cta-button";

interface IIconTeaserGridItem {
    BackgroundColor?: string;
    CtaBackgroundColor?: string;
    CtaColor?: string;
    CtaLinkUrl?: string;
    Headline?: string;
    HeadlineColor?: string;
    ImageUrl?: string;
    TeaserText?: string;
    TeaserTextColor?: string;
    Trumpet?: string;
    Type: "Background" | "Icon" | "Image";
    Icon?: string;
    IconColor?: string;
}

interface IIconTeaserGridProps {
    Items: Array<IIconTeaserGridItem>;
}

function IconTeaserGrid(props: IIconTeaserGridProps) {
    const baseClass = "icon-teaser-grid";
    const rootClasses = classNames(`${baseClass}-container`, {
        "icon-teaser-grid--wide": props.Items?.length <= 1,
        "icon-teaser-grid--normal": props.Items?.length > 1
    });

    return (
        <div className="content-module">
            <div className={rootClasses}>
                {props.Items.map((item, index) => {
                    return (
                        <div
                            key={index}
                            className={`${baseClass}__item ${baseClass}__item--${item.Type.toLowerCase()}`}
                        >
                            <div
                                style={
                                    item.ImageUrl ? { backgroundImage: `url('${item.ImageUrl}')` } : undefined
                                }
                                className={classNames(`${baseClass}__inner-container`, {
                                    [`${item.BackgroundColor}--bg `]: !!item.BackgroundColor
                                })}
                            >
                                <div className={`${baseClass}__content`}>
                                    <div className={`${baseClass}__text-container`}>
                                        {item.Icon && (
                                            <div
                                                className={classNames(`${baseClass}__icon`, {
                                                    [`${item.IconColor}--text `]: !!item.IconColor
                                                })}
                                                dangerouslySetInnerHTML={{ __html: item.Icon }}
                                            />
                                        )}

                                        {item.Trumpet && (
                                            <div
                                                className={classNames(`${baseClass}__trumpet `, {
                                                    [`${item.HeadlineColor}--text`]: !!item.HeadlineColor
                                                })}
                                            >
                                                {item.Trumpet}
                                            </div>
                                        )}
                                        {item.Headline && (
                                            <div
                                                className={classNames(`${baseClass}__title `, {
                                                    [`${item.HeadlineColor}--text`]: !!item.HeadlineColor
                                                })}
                                            >
                                                {item.Headline}
                                            </div>
                                        )}
                                        {item.TeaserText && (
                                            <div
                                                className={classNames({
                                                    [`${item.TeaserTextColor}--text`]: !!item.TeaserTextColor
                                                })}
                                                dangerouslySetInnerHTML={{ __html: item.TeaserText }}
                                            ></div>
                                        )}
                                        {item.CtaLinkUrl && (
                                            <div
                                                className={`action-button-container ${baseClass}__button-container`}
                                            >
                                                <CustomPrimaryCtaButton
                                                    CtaBackgroundColorClass={item.CtaBackgroundColor}
                                                    CtaTextColorClass={item.CtaColor}
                                                    CtaLink={item.CtaLinkUrl}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default IconTeaserGrid;
